import React from "react";
import Navbar from "../Navbar/Navbar";
import Bredcom from "../Bredcom/Bredcom";
import Footer from "../Footer/Footer";
import { Link } from "react-router-dom";

function KorporativnoUpravljanjePM() {
  return (
    <>
      <Navbar />
      <Bredcom title="Početna" subtitle="Korporativno upravljanje" />
      <div className="container mt-4 pt-40">
        <div className="row">
          <div className="col-md-8">
            <div className="content-container">
              <h2 className="section-title">Korporativno upravljanje</h2>
              <p>
                <strong>Studijski program:</strong> Pravo
              </p>
              <p>
                <strong>Naziv predmeta:</strong> Korporativno upravljanje
              </p>
              <p>
                <strong>Nastavnik:</strong>
              </p>
              <p>
                <strong>Status predmeta:</strong> Izborni
              </p>
              <p>
                <strong>Broj ECTS:</strong> 7
              </p>
              <p>
                <strong>Uslov:</strong> nema
              </p>
              <h3>Cilj predmeta</h3>
              <p>
                Cilj predmeta Korporativno upravljanje je da studente upozna sa
                pravnim režimom upravljanja privrednim društvima. Studenti će se
                upoznati sa opštim posebnim teorijskim i praktičnim znanjima o
                preduzetništvu i upravljanju o načinu vođenja i rukovođenja
                preduzećima odnosno o menadžmentu. Takođe cilj ovog predmeta je
                da studentima pruži znanja iz oblasti mendžmenta veze
                menadžmenta i pravnog okvira poslovanja kao i da ukaže na ulogu
                države u privrednim tokovima odnosno da pruži znanja i vještine
                koji im mogu biti od koristi u rukovođenju firmama
                pozicioniranju na tržistu i u društvu i u ostvarivanju što većeg
                profita.
              </p>
              <h3>Ishod predmeta</h3>
              <p>
                Ishod predmeta je da svojim programskim sadržajem obezbijedi
                studentima neophodna teoretska znanja o suštini rukovođenja
                preduzećima i njegovim osnovnim pojmovima. Studenti će nakon
                izučavanja ove grane prava i položenog ispita steći znanja i
                vještine da samostalno sa pravnog aspekta osniva organizuje
                rukovodi i zastupa bilo koji oblik privrednog drušva kao i da
                zaključuje ugovore iz domena privrede i trgovine. Takođe
                studenti će steći znanja i vještine: o organizaciji i planiranja
                u menadžmentu rukovođenju ljudskim resursima uticaju medija i
                javnosti na rad preduzeća kao i na buduće potencijale sa
                posebnim osvrtom na informacione tehnologije i ukrupljavanje
                tržišta. Student će ovladati tehnikom pregovaranja i zaključenja
                ugovora u privredi.
              </p>
              <h3>Sadržaj predmeta</h3>
              <p>
                Teorijska nastava sadrži: Uvod u menadžment osnovne osobine i
                načela; funkcije menadžmenta: planiranje organizovanje
                rukovođenje kontrolisanje; Planiranje – pojam definicija i
                osnovi planiranja; Strateški menadžment i strateško planiranje;
                Organizovanje i organizaciona struktura upravljanje ljudskim
                resursima; Interna i eksterna komunikacija Odnosi s javnošću
                Sistemi kontrolisanja; Informacione tehnologije i njihov uticaj
                i moć; Radni odnosi u privrednom društvu; Načini ocjenjivanja
                nagrađivanja i kažnjavanja zaposlenih; Tehnike donošenja odluka;
                Organizacija: pojam bitni elementi i osnivanje; Vrste
                organizacija Imovina kapital i članovi organizacije Upravljanje
                organizacijom i organi organizacije Povezivanje organizacija
                Država kao osnivač i koosnivač organizacije Finansiranje i
                kontrola rada organizacije Korporativno upravljanje u Evropskoj
                uniji.
              </p>
              <p>
                Praktična nastava: Praktična nastava će se organizovati kako na
                fakultetu tako i posjetama državnim institucijama i privatnim
                kompanijama. Na časovima predavanja i vježbi studenti će imati
                aktivnu ulogu kroz raznorazne debate i studije slučaja. Takođe
                analiziraće se stručna praksa i primjeri iz prakse.
              </p>

              <h3>Metode izvođenja nastave</h3>
              <p>
                Predаvаnjа, interаktivni oblici nаstаve, аnаlizа slučаjevа,
                individuаlni i grupni projekti.
              </p>

              <h3 className="pt-20 pb-10">Plan rada</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Nedjelja</th>
                    <th>Fond časova</th>
                    <th>Sadržaj</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Pripremna</td>
                    <td>Upoznavanje, dogovor o radu i slično</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>I</td>
                    <td>3P + 1V</td>
                    <td>Uvod u menadžment osnovne osobine i načela;</td>
                  </tr>
                  <tr>
                    <td>II</td>
                    <td>3P + 1V</td>
                    <td>
                      Funkcije menadžmenta: planiranje, organizovanje,
                      rukovođenje, kontrolisanje;
                    </td>
                  </tr>
                  <tr>
                    <td>III</td>
                    <td>3P + 1V</td>
                    <td>Planiranje – pojam, definicija i osnovi planiranja;</td>
                  </tr>
                  <tr>
                    <td>IV</td>
                    <td>3P + 1V</td>
                    <td>Strateški menadžment i strateško planiranje;</td>
                  </tr>
                  <tr>
                    <td>V</td>
                    <td>3P + 1V</td>
                    <td>
                      Organizovanje i organizaciona struktura, upravljanje
                      ljudskim resursima; Interna i eksterna komunikacija
                    </td>
                  </tr>
                  <tr>
                    <td>VI</td>
                    <td>Kolokvijum I</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>VII</td>
                    <td>3P + 1V</td>
                    <td>
                      Odnosi s javnošću, Sistemi kontrolisanja; Informacione
                      tehnologije i njihov uticaj i moć;
                    </td>
                  </tr>
                  <tr>
                    <td>VIII</td>
                    <td>3P + 1V</td>
                    <td>
                      Radni odnosi u privrednom društvu; Načini ocjenjivanja,
                      nagrađivanja i kažnjavanja zaposlenih; Tehnike donošenja
                      odluka;
                    </td>
                  </tr>
                  <tr>
                    <td>IX</td>
                    <td>3P + 1V</td>
                    <td>Organizacija: pojam, bitni elementi i osnivanje;</td>
                  </tr>
                  <tr>
                    <td>X</td>
                    <td>3P + 1V</td>
                    <td>Vrste organizacija</td>
                  </tr>
                  <tr>
                    <td>XI</td>
                    <td>3P + 1V</td>
                    <td>Imovina, kapital i članovi organizacije</td>
                  </tr>
                  <tr>
                    <td>XII</td>
                    <td>Kolokvijum II</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XIII</td>
                    <td>3P + 1V</td>
                    <td>
                      Upravljanje organizacijom i organi organizacije,
                      Povezivanje organizacija
                    </td>
                  </tr>
                  <tr>
                    <td>XIV</td>
                    <td>3P + 1V</td>
                    <td>Država kao osnivač i koosnivač organizacije</td>
                  </tr>
                  <tr>
                    <td>XV</td>
                    <td>3P + 1V</td>
                    <td>
                      Finansiranje i kontrola rada organizacije, Korporativno
                      upravljanje u Evropskoj uniji
                    </td>
                  </tr>
                  <tr>
                    <td>XVI</td>
                    <td>Sveobuhvatni ispit</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVII</td>
                    <td>Ovjera semestra i upis ocjena</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>XVIII</td>
                    <td>Popravni ispitni rok</td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Obaveze studenata</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Obaveze studenata</th>
                    <th>U toku nastave</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Obaveze studenata u toku nastave</td>
                    <td>
                      Studenti su obavezni da pohađaju nastavu, vježbe i ispite
                    </td>
                  </tr>
                  <tr>
                    <td>Konsultacije</td>
                    <td>
                      Konsultacije se održavaju sa nastavnikom i saradnikom
                      poslije časova
                    </td>
                  </tr>
                  <tr>
                    <td>Opterećenje studenata u časovima</td>
                    <td>
                      <table className="table table-bordered ofpep-section">
                        <thead>
                          <tr>
                            <th>Nedjeljno</th>
                            <th>U semestru</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Ukupno: 4 č / 3h</td>
                            <td>Ukupno: 80 č</td>
                          </tr>
                          <tr>
                            <td>Predavanja: 3 č / 2.15h</td>
                            <td>Nastava + završni ispit: 60 č</td>
                          </tr>
                          <tr>
                            <td>Vježbe: 1 č / 0.45h</td>
                            <td>Priprema i ovjera semestra: 6 č</td>
                          </tr>
                          <tr>
                            <td>Individualni rad:</td>
                            <td>Priprema i polaganje popravnog ispita: 14 č</td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>

              <h3 className="pt-20 pb-10">Ocjenjivanje</h3>
              <table className="table table-bordered ofpep-section">
                <thead>
                  <tr>
                    <th>Ocjena</th>
                    <th>Broj poena</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>A(odličan)</td>
                    <td>91-100</td>
                  </tr>
                  <tr>
                    <td>B(vrlo dobar)</td>
                    <td>81-90</td>
                  </tr>
                  <tr>
                    <td>C(dobar)</td>
                    <td>71-80</td>
                  </tr>
                  <tr>
                    <td>D(zadovoljava)</td>
                    <td>61-70</td>
                  </tr>
                  <tr>
                    <td>E(dovoljan)</td>
                    <td>51-60</td>
                  </tr>
                  <tr>
                    <td>F(nedovoljan)</td>
                    <td>0-50</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="col-md-4 pt-10">
            <aside className="sidebar-widget">
              <section
                id="custom_html-5"
                className="widget_text widget widget_custom_html"
              >
                <h2 className="widget-title">Zapratite nas</h2>
                <div className="textwidget custom-html-widget">
                  <div className="widget-social">
                    <a
                      href="https://www.facebook.com/fpebar.me"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-facebook-f" />
                    </a>
                    <a
                      href="https://www.instagram.com/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-instagram" />
                    </a>
                    <a
                      href="https://www.youtube.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-youtube" />
                    </a>
                    <a
                      href="https://www.tiktok.com/@fpepbar"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on Tiktok"
                      title="Tiktok"
                    >
                      <i className="fab fa-tiktok" />
                    </a>
                    <a
                      href="https://www.linkedin.com/school/fpepbar/"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Follow us on LinkedIn"
                      title="LinkedIn"
                    >
                      <i className="fab fa-linkedin-in" />
                    </a>
                  </div>
                </div>
              </section>
              <section id="categories-1" className="widget widget_categories">
                <h2 className="widget-title">Korisni linkovi</h2>
                <ul>
                  <li className="cat-item cat-item-16">
                    <Link to="/o-fpep">O Fakultetu</Link>
                  </li>
                  <li className="cat-item cat-item-23">
                    <Link to="/akreditacija-fpep">Akreditacija FPEP-a</Link>
                  </li>
                  <li className="cat-item cat-item-18">
                    <Link to="/upis">Upis</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/cijene-studija">Školarina</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/erasmus">Erasmus+</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/projekti">Projekti</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/dom-studenata">Dom studenata</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/galerija">Galerija</Link>
                  </li>
                  <li className="cat-item cat-item-22">
                    <Link to="/novosti">Novosti</Link>
                  </li>
                </ul>
              </section>
              <section
                id="recent-posts-4"
                className="widget widget_recent_entries"
              >
                <h2 className="widget-title">Studijski programi</h2>
                <ul>
                  <li>
                    <span className="post-date">
                      <strong>Osnovne studije</strong> <br />
                    </span>
                    <Link to="/racunovodstvo-finansije-i-bankarstvo">
                      Računovodstvo, bankarstvo i finansije
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/menadzment">
                      Menadžment
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-osnovne">
                      Pravo
                      <br />
                    </Link>
                  </li>
                  <li>
                    <span className="post-date">
                      <strong>Master studije</strong> <br />
                    </span>
                    <Link to="/poslovna-ekonomija">
                      Poslovna ekonomija
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/ekonomija-javnog-sektora">
                      Ekonomija javnog sektora
                      <br />
                    </Link>
                  </li>
                  <li>
                    <Link to="/pravo-master">
                      Pravo
                      <br />
                    </Link>
                  </li>
                </ul>
              </section>
            </aside>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default KorporativnoUpravljanjePM;
